import i18next from "../i18n/config";

export const getIndividualClientText = () => ({
  title: i18next.t("common.forIndividual"),
  blocks: [
    {
      question: i18next.t("FAQ.individual.question1"),
      answer: i18next.t("FAQ.individual.answer1"),
    },
    {
      question: i18next.t("FAQ.individual.question2"),
      answer: i18next.t("FAQ.individual.answer2"),
    },
    {
      question: i18next.t("FAQ.individual.question3"),
      answer: i18next.t("FAQ.individual.answer3"),
    },
    {
      question: i18next.t("FAQ.individual.question4"),
      answer: i18next.t("FAQ.individual.answer4"),
    },
    {
      question: i18next.t("FAQ.individual.question5"),
      answer: i18next.t("FAQ.individual.answer5"),
    },
    {
      question: i18next.t("FAQ.individual.question6"),
      answer: i18next.t("FAQ.individual.answer6"),
    },
  ],
});

export const getBusinessesClientText = () => ({
  title: i18next.t("common.forBusiness"),
  blocks: [
    {
      question: i18next.t("FAQ.business.question1"),
      answer: i18next.t("FAQ.business.answer1"),
    },
    {
      question: i18next.t("FAQ.business.question2"),
      answer: i18next.t("FAQ.business.answer2"),
    },
    {
      question: i18next.t("FAQ.business.question3"),
      answer: i18next.t("FAQ.business.answer3"),
    },
    {
      question: "question4",
      answer: i18next.t("FAQ.business.answer4"),
    },
    {
      question: i18next.t("FAQ.business.question5"),
      answer: i18next.t("FAQ.business.answer5"),
    },
    {
      question: i18next.t("FAQ.business.question6"),
      answer: i18next.t("FAQ.business.answer6"),
    },
  ],
});
